import React from 'react';
import './RaceCard.css'; // estilos separados

const statusColors = {
  schedule: '#ccc',
  live: '#28a745',
  finished: '#007bff'
};

const genderIcons = {
  Man: '♂️',
  Woman: '♀️',
  Other: '⚧️'
};

const RaceCard = ({ race }) => {
  const {     raceName,
    raceDay,
    gender,
    fileStartList,
    fileResults,
    status,
    category,
    eventCode } = race;

  return (
    <div className="race-card">
      <div
        className="race-pleca"
        style={{ backgroundColor: statusColors[status?.toLowerCase()] || '#999' }}
      />
      <div className="race-content">
        <h3>{genderIcons[gender] || '❓'}{raceName}</h3>
        <p><strong>schedule:</strong> {new Date(raceDay).toLocaleDateString()} {new Date(raceDay).toLocaleTimeString()}</p>
        <p><strong>State:</strong> {status}</p>
        <div className="race-actions">
          {fileStartList && (
            <a href={fileStartList} target="_blank" rel="noopener noreferrer" title="Descargar lista de salida" className='input-group-text bg-success2 text-white'>
              📄StartList
            </a>
          )}
          {fileResults && (
            <a href={fileResults} target="_blank" rel="noopener noreferrer" title="Descargar resultados" className='input-group-text bg-secondary2 text-white'>
              📄 Results
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default RaceCard;
